// extracted by mini-css-extract-plugin
module.exports = {"video":"rich-text-renderer_video__CtKXT","rtParagraph":"rich-text-renderer_rtParagraph__gtu_U"};